var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAxos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1562 1562",
    width: 1562,
    height: 1562,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Axos_Financial_Inc_Logo_Color-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #faa74a } \n\t\t.s1 { fill: #1e3860 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path887",
    className: "s0",
    d: "m916 782.5l-760.3 759.8c-25.7 25.7-70.4 25.7-96.1 0l-39.5-39.5c-25.7-25.7-25.7-70.3 0-96l626.4-626-626.4-626c-25.7-25.7-25.7-70.3 0-96.1l39.5-39.4c25.7-25.7 70.4-25.7 96.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path891",
    className: "s1",
    d: "m1543.2 155.6l-531.1 530-135.6-135.5 530.3-529.9c25.7-25.8 70.3-25.8 96.1 0l39.4 39.4c25.8 25.7 25.8 68.6 0.9 96zm-0.9 1345.5l-39.4 39.5c-25.8 25.7-70.4 25.7-96.1 0l-530.3-530.9 135.6-135.4 531.1 529.9c24.9 27.5 24.9 69.5-0.9 96.9z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxos);
export default __webpack_public_path__ + "static/media/AXOS.40a1f688667e5a75eaf8268f161dc598.svg";
export { ForwardRef as ReactComponent };